import { FC } from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { formatForRoute, getFirstSubsection } from '../utils';
import { Section } from '../FileStructure';

interface SectionState {
    [section: string]: boolean;
}

interface ListItemProps {
    section: Section;
    sectionState: SectionState;
    toggleSection: (section: string) => void;
    hasSubsections: boolean;
    padding?: number;
    isSection?: boolean;
    subsection?: Section;
}

const ListItem: FC<ListItemProps> = ({ section, sectionState, toggleSection, hasSubsections, padding, isSection, subsection }) => {
    const { pathname } = useLocation();

    const splitPath = pathname.split("/");
    const sectionPath = splitPath.slice(-2).join("/");

    const handleKeyPress = (event: React.KeyboardEvent, section: string) => {
        if (event.key === 'Enter' || event.key === ' ') {
            toggleSection(section);
        }
    };

    const firstSubsection = getFirstSubsection(section.title);

    let toPath = `${section.url}/${formatForRoute(firstSubsection)}`;
    let navText = `${section.index} ${section.title}`;
    let sectionToToggle = section.title;

    // handle third level subsections
    if (!isSection && subsection) {
        toPath = `${section.url}/${subsection.url}`;
        navText = `${subsection.index} ${subsection.title}`;
        sectionToToggle = `${section.title}/${subsection.title}`;
    }
    return (
        <li>
            <Link
                className="route-links"
                to={toPath}
            >
                <ListItemButton sx={{ pl: padding && padding }} onKeyDown={(e) => handleKeyPress(e, section.title)}
                    selected={
                        section.url !== "appendix" && (sectionPath === toPath)
                    }
                >
                    <ListItemText primary={navText} />
                    {hasSubsections && (
                        <span className="toggle-span" onClick={() => toggleSection(sectionToToggle)}>
                            {sectionState[sectionToToggle] ? <ExpandLess /> : <ExpandMore />}
                        </span>
                    )}
                </ListItemButton>
            </Link>
        </li>
    );
};
export default ListItem;
